import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
const About = lazy(() => import("@/pages/About"));
const Terminals = lazy(() => import("@/pages/Terminals"));
const TerminalDetail = lazy(() => import("@/pages/TerminalDetail"));
const FinancialReports = lazy(() => import("@/pages/FinancialReports"));
const GeneralAssembly = lazy(() => import("@/pages/GeneralAssembly"));
const ContentPage = lazy(() => import("@/pages/ContentPage"));
const Contact = lazy(() => import("@/pages/Contact"));
const Documents = lazy(() => import("@/pages/Documents"));
const DocumentOpen = lazy(() => import("@/pages/DocumentOpen"));
const LegacyFile = lazy(() => import("@/pages/LegacyRedirect").then((m) => ({ default: m.LegacyFile })));
const LegacyQuery = lazy(() => import("@/pages/LegacyRedirect").then((m) => ({ default: m.LegacyQuery })));
const NotFound = lazy(() => import("@/pages/NotFound"));

const AdminApp = lazy(() => import("@/admin/AdminApp"));

const HomeRoute = () => {
  const { search } = useLocation();
  return /[?&](page_id|p|m)=/.test(search) ? <LegacyQuery search={search} /> : <Home />;
};

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <Routes>
          <Route path="/yonetim/*" element={<Suspense fallback={null}><AdminApp /></Suspense>} />
          <Route element={<Layout />}>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/hakkimizda" element={<About />} />
            <Route path="/terminaller" element={<Terminals />} />
            <Route path="/terminaller/:slug" element={<TerminalDetail />} />
            <Route path="/finansal-raporlar" element={<FinancialReports />} />
            <Route path="/genel-kurul" element={<GeneralAssembly />} />
            <Route path="/kalite-politikamiz" element={<ContentPage slug="kalite-politikamiz" />} />
            <Route path="/kvkk" element={<ContentPage slug="kvkk" crumb="Kurumsal" />} />
            <Route path="/cerez-politikasi" element={<ContentPage slug="cerez-politikasi" />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/belgeler" element={<Documents />} />
            <Route path="/belgeler/:file" element={<DocumentOpen />} />
            <Route path="/wp-content/*" element={<LegacyFile />} />
            <Route path="/dosya/*" element={<LegacyFile />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
